import * as VueRouter from "vue-router";

import PasswordReset from "../components/PasswordReset";

import MyAccount from "../components/MyAccount.vue";
import Dashboard from "../components/Dashboard.vue";
import DirectToDealerOnboarding from "../components/DirectToDealerOnboarding.vue";
import DirectToDealerOnboardingLanding from "../components/DirectToDealerOnboardingLanding.vue";
import AdminPriceList from "../components/AdminPriceList.vue";

import Orders from "../components/orders/Orders.vue";
import OrderInfo from "../components/orders/OrderInfo.vue";
import OrderEdit from "../components/orders/OrderEdit.vue";
import OrderCreate from "../components/orders/OrderCreate.vue";
import OrderCreateAdmin from "../components/orders/OrderCreateAdmin.vue";
import BogoOrders from "../components/orders/BogoOrders.vue";
import SyncedOrders from "../components/orders/SyncedOrders.vue";

import Invoices from "../components/invoices/Invoices.vue";
import InvoiceInfo from "../components/invoices/InvoiceInfo.vue";

import PriceLists from "../components/PriceLists.vue";
import Contact from "../components/Contact.vue";

import UserInfo from "../components/users/UserInfo.vue";

import Dealers from "../components/dealers/Dealers.vue";
import DealerInfo from "../components/dealers/DealerInfo.vue";

import SalesRep from "../components/SalesRep.vue";

import Materials from "../components/Materials.vue";

import AvailableInventory from "../components/AvailableInventory";

import OrderLinesReport from "../components/OrderLinesReport";

import QuoteCreate from "../components/quotes/QuoteCreate.vue";
import Quotes from "../components/quotes/Quotes.vue";
import QuoteInfo from "../components/quotes/QuoteInfo.vue";
import QuoteEdit from "../components/quotes/QuoteEdit.vue";

import BuyGroupDates from "../components/buy-group-dates/BuyGroupDates.vue";
import BuyGroupDateCreate from "../components/buy-group-dates/BuyGroupDateCreate.vue";
import BuyGroupDateEdit from "../components/buy-group-dates/BuyGroupDateEdit.vue";

import FileApprovalQueue from "../components/file_approval_queue/FileApprovalQueue.vue";
import Commissions from "../components/Commissions.vue";
import FreeShippingSettings from "../components/FreeShippingSettings.vue";

import Settings from "../components/settings/Settings.vue";


/********************************************* SPEQS *********************************************/
import SpeqDashboard from "../components/speq/SpeqDashboard.vue";
import SpeqPriceLists from "../components/speq/SpeqPriceLists.vue";
import SpeqContact from "../components/speq/SpeqContact.vue";

import SpeqSalesRep from "../components/speq/SpeqSalesRep.vue";
import SpeqMaterials from "../components/speq/SpeqMaterials.vue";
import SpeqAvailableInventory from "../components/speq/SpeqAvailableInventory";
import SpeqFileApprovalQueue from "../components/speq/file_approval_queue/SpeqFileApprovalQueue.vue";
import SpeqOrderLinesReport from "../components/speq/SpeqOrderLinesReport.vue";
import SpeqAdminPriceList from "../components/speq/SpeqAdminPriceList.vue";
import SpeqSettings from "../components/speq/settings/SpeqSettings.vue";

import SpeqOnboarding from "../components/speq/SpeqOnboarding.vue";

import SpeqOrders from "../components/speq/orders/SpeqOrders.vue";
import SpeqOrderInfo from "../components/speq/orders/SpeqOrderInfo.vue";
import SpeqOrderEdit from "../components/speq/orders/SpeqOrderEdit.vue";
import SpeqOrderCreate from "../components/speq/orders/SpeqOrderCreate.vue";
import SpeqOpenSerialNumbers from "../components/speq/orders/SpeqOpenSerialNumbers.vue";

import SpeqInvoices from "../components/speq/invoices/SpeqInvoices.vue";
import SpeqInvoiceInfo from "../components/speq/invoices/SpeqInvoiceInfo.vue";

import SpeqUserInfo from "../components/speq/users/SpeqUserInfo.vue";

import SpeqDealers from "../components/speq/dealers/SpeqDealers.vue";
import SpeqDealerInfo from "../components/speq/dealers/SpeqDealerInfo.vue";

import SpeqQuoteCreate from "../components/speq/quotes/SpeqQuoteCreate.vue";
import SpeqQuotes from "../components/speq/quotes/SpeqQuotes.vue";
import SpeqQuoteInfo from "../components/speq/quotes/SpeqQuoteInfo.vue";
import SpeqQuoteEdit from "../components/speq/quotes/SpeqQuoteEdit.vue";

import SpeqBuyGroupDates from "../components/speq/buy-group-dates/SpeqBuyGroupDates.vue";
import SpeqBuyGroupDateCreate from "../components/speq/buy-group-dates/SpeqBuyGroupDateCreate.vue";
import SpeqBuyGroupDateEdit from "../components/speq/buy-group-dates/SpeqBuyGroupDateEdit.vue";
import SpeqValidDocuments from "../components/speq/SpeqValidDocuments.vue";

import Unauthorized from "@/components/Unauthorized.vue";

import { store } from "../store";
import { canAccessSpeq } from "@/helpers";

// ROUTES
const routes = [
    { path: "/", name: "dashboard", component: Dashboard },
    { path: "/price-lists", component: PriceLists },
    { path: "/contact", name: "contact", component: Contact },
    { path: "/my-account", name: "myAccount", component: MyAccount },

    // ORDERS
    { path: "/all-orders", name: "orders", component: Orders },
    { path: "/new-order", component: OrderCreate, name: "OrderCreate", props: true, meta: { params: true } },
    { path: "/new-order-admin", component: OrderCreateAdmin },
    {
        path: "/order/view/:id",
        name: "orderInfo",
        component: OrderInfo,
        props: true,
    },
    {
        path: "/order/edit/:id",
        name: "orderEdit",
        component: OrderEdit,
        props: true,
    },

    // SYNCED ORDERS
    { path: "/synced-orders", name: "syncedOrders", component: SyncedOrders },

    // BOGO ORDERS
    { path: "/all-bogo-orders", name: "bogoOrders", component: BogoOrders },

    // INVOICES
    { path: "/invoices", component: Invoices },
    {
        path: "/invoice/view/:id",
        name: "invoiceInfo",
        component: InvoiceInfo,
        props: true,
    },

    // USERS
    {
        path: "/user/view/:id",
        name: "userInfo",
        component: UserInfo,
        props: true,
    },

    // DEALERS
    {
        path: "/dealers",
        name: "dealers",
        component: Dealers,
    },
    {
        path: "/dealer/view/:id",
        name: "dealerInfo",
        component: DealerInfo,
        props: true,
    },
    { path: "/sales-reps", component: SalesRep },
    { path: "/all-materials/:id?",name:'materials', component: Materials },
    { path: "/all-available-inventories", component: AvailableInventory },
    { path: "/approval-queue", component: FileApprovalQueue },
    { path: "/order-lines-report", component: OrderLinesReport },

    // QUOTES
    { path: "/create-quote", name: "create-quote", component: QuoteCreate },
    { path: "/quotes", name: "quotes", component: Quotes },
    {
        path: "/quote/view/:id",
        name: "quoteInfo",
        component: QuoteInfo,
        props: true,
    },
    {
        path: "/quote/edit/:id",
        name: "quoteEdit",
        component: QuoteEdit,
        props: true,
    },

    // BUY GROUP DATES
    {
        path: "/buy-group-dates",
        name: "buyGroupDates",
        component: BuyGroupDates,
    },
    {
        path: "/create-buy-group-date",
        name: "createBuyGroupDate",
        component: BuyGroupDateCreate,
    },
    {
        path: "/buy-group-date/edit/:id",
        name: "buyGroupDateEdit",
        component: BuyGroupDateEdit,
        props: true,
    },
    {
        path: "/admin-price-list",
        name: "adminPriceList",
        component: AdminPriceList,
    },

    {
        path: "/direct-to-dealer-onboarding/:id?",
        name: "directToDealerOnboarding",
        component: DirectToDealerOnboarding,
        props: true,
    },

    {
        path: "/direct-to-dealer-onboarding-landing",
        name: "DirectToDealerOnboardingLanding",
        component: DirectToDealerOnboardingLanding,
    },
    {
        path: "/commissions",
        name: "Commissions",
        component: Commissions,
    },

    /********************************************* SPEQS *********************************************/
    { path: "/speq", name: "speqDashboard", component: SpeqDashboard, meta: { is_speq: true } },
    { path: "/speq/price-lists", component: SpeqPriceLists, meta: { is_speq: true } },
    { path: "/speq/contact", name: "speqContact", component: SpeqContact, meta: { is_speq: true } },

    { path: "/speq/sales-reps", component: SpeqSalesRep, meta: { is_speq: true } },
    { path: "/speq/all-materials/:id?",name:'speqMaterials', component: SpeqMaterials, meta: { is_speq: true } },
    { path: "/speq/all-available-inventories", component: SpeqAvailableInventory, meta: { is_speq: true } },
    { path: "/speq/approval-queue", component: SpeqFileApprovalQueue, meta: { is_speq: true } },
    { path: "/speq/order-lines-report", component: SpeqOrderLinesReport, meta: { is_speq: true } },
    { path: "/speq/admin-price-list", name: "speqAdminPriceList", component: SpeqAdminPriceList, meta: { is_speq: true } },
    { path: "/speq/settings", name: "speqSettings", component: SpeqSettings, meta: { is_speq: true } },
    { path: "/speq/valid-documents", name: "speqValidDocuments", component: SpeqValidDocuments, meta: { is_speq: true } },
    {
        path: "/speq/speq-onboarding-landing",
        name: "speqOnboarding",
        component: SpeqOnboarding,
        // meta: { is_speq: true }
    },
    // ORDERS
    { path: "/speq/all-orders", name: "speqOrders", component: SpeqOrders, meta: { is_speq: true } },
    { path: "/speq/new-speq-orders", name: "newSpeqOrders", component: SpeqOrders },
    { path: "/speq/new-order", component: SpeqOrderCreate, name: "speqOrderCreate", props: true, meta: { is_speq: true, params: true } },
    { 
        path: "/speq/order/view/:id",
        name: "speqOrderInfo",
        component: SpeqOrderInfo,
        props: true,
        meta: { is_speq: true }
    },
    {
        path: "/speq/order/edit/:id",
        name: "speqOrderEdit",
        component: SpeqOrderEdit,
        props: true,
        meta: { is_speq: true }
    },
    // OPEN SERIAL NUMBERS
    { path: "/speq/open-serial-numbers", name: "speqOpenSerialNumbers", component: SpeqOpenSerialNumbers, meta: { is_speq: true } },
    // INVOICES
    { path: "/speq/invoices", component: SpeqInvoices, meta: { is_speq: true } },
    {
        path: "/speq/invoice/view/:id",
        name: "speqInvoiceInfo",
        component: SpeqInvoiceInfo,
        props: true,
        meta: { is_speq: true }
    },
    // USERS
    {
        path: "/speq/user/view/:id",
        name: "speqUserInfo",
        component: SpeqUserInfo,
        props: true,
        meta: { is_speq: true }
    },
    // DEALERS
    {
        path: "/speq/dealers",
        name: "speqDealers",
        component: SpeqDealers,
        meta: { is_speq: true }
    },
    {
        path: "/speq/dealer/view/:id",
        name: "speqDealerInfo",
        component: SpeqDealerInfo,
        props: true,
        meta: { is_speq: true }
    },
    // QUOTES
    { path: "/speq/create-quote", name: "speqCreate-quote", component: SpeqQuoteCreate, meta: { is_speq: true } },
    { path: "/speq/quotes", name: "speqQuotes", component: SpeqQuotes, meta: { is_speq: true } },
    {
        path: "/speq/quote/view/:id",
        name: "speqQuoteInfo",
        component: SpeqQuoteInfo,
        props: true,
        meta: { is_speq: true } 
    },
    {
        path: "/speq/quote/edit/:id",
        name: "speqQuoteEdit",
        component: SpeqQuoteEdit,
        props: true,
        meta: { is_speq: true } 
    },

    // BUY GROUP DATES
    {
        path: "/speq/buy-group-dates",
        name: "speqBuyGroupDates",
        component: SpeqBuyGroupDates,
        meta: { is_speq: true } 
    },
    {
        path: "/speq/create-buy-group-date",
        name: "speqCreateBuyGroupDate",
        component: SpeqBuyGroupDateCreate,
        meta: { is_speq: true } 
    },
    {
        path: "/speq/buy-group-date/edit/:id",
        name: "speqBuyGroupDateEdit",
        component: SpeqBuyGroupDateEdit,
        props: true,
        meta: { is_speq: true } 
    },
    {
        path: "/free-shipping-settings",
        name: "FreeShippingSettings",
        component: FreeShippingSettings,
    },
    {
        path: "/settings",
        name: "Settings",
        component: Settings,
        props: true,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/password/reset",
        name: "PasswordReset",
        component: PasswordReset,
    },
    {
      path: "/unauthorized",
      name: "unauthorized",
      component: Unauthorized
    }
];

const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory("/"),
    routes,
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
});

router.beforeEach(async (to, from, next) => {
//   if (store.state.user.is_password_force_reset && to.path !== '/password/reset') {
//     next('/password/reset');
//   }

  const requiredRule = to.meta.is_speq ?? false;
  const isSpeq = localStorage.getItem('isSpeq') === 'true';

  // limit speq route access
  if (to.meta.is_speq) {
    if (!canAccessSpeq()) {
      next({name: 'unauthorized'});
    }

    localStorage.removeItem('is_selected_location_speq');
  }

  if (requiredRule === isSpeq) {
    //   console.log('ALLOWED');
      next();
  } else {
      localStorage.removeItem("isSpeq");
    //   console.log('NOT ALLOWED');
      next('/');
  }
});

export default router;
